import { Table } from 'reactstrap'
import { isOnlyTimetracker } from 'utils/authService'
import s from './UserTable.scss'

const WORK_TYPES = {
  REGULAR: 'Regular',
  OVERTIME: 'Overtime',
  SECOND_SHIFT: 'Second Shift',
  THIRD_SHIFT: 'Third Shift'
}

const UserTable = ({ data, date }) => {
  return (
    <div key={date} className={s.dayStats}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <span style={{ fontWeight: 600 }}>{date}</span>
        <span style={{ fontSize: 18 }}>{data?.totalHours} hrs</span>
      </div>
      <hr />
      <Table bordered>
        <thead>
          <tr>
            <th style={{ width: '12%' }}>Opportunity</th>
            <th style={{ width: '12%' }}>Quote Number</th>
            <th style={{ width: '12%' }}>Project Number</th>
            <th style={{ width: '12%' }}>Service</th>
            <th style={{ width: '12%' }}>Billable</th>
            <th style={{ width: '12%' }}>Work Type</th>
            <th style={{ width: '12%' }}>Description</th>
            <th style={{ width: '12%' }}>Hours</th>
          </tr>
        </thead>
        <tbody>
          {data.data.map((entry, index) => {
            return (
              <tr key={index}>
                <td style={{ width: '14%' }}>
                  {isOnlyTimetracker() ? (
                    entry.dealName
                  ) : (
                    <a href={`/opportunities/${entry.dealId}`} target="_blank" rel="noreferrer">
                      {entry.dealName}
                    </a>
                  )}
                </td>
                <td style={{ width: '12%' }}>{entry.quoteNumber}</td>
                <td style={{ width: '12%' }}>{entry.projectNumber}</td>
                <td style={{ width: '12%' }}>
                  {entry.workType !== 'TIME_OFF' ? entry.service : `Time Off - ${entry.service}`}
                </td>
                <td style={{ width: '12%' }}>{entry.billable ? 'Yes' : 'No'}</td>
                <td style={{ width: '12%' }}>{WORK_TYPES[entry.workType]}</td>
                <td style={{ width: '12%' }}>{entry.description}</td>
                <td style={{ width: '12%' }}>{entry.hours}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  )
}

export default UserTable
